"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test = void 0;
const tslib_1 = require("tslib");
const ad_block_detection_1 = require("./ad-block-detection");
const test = (options = { logLevel: 'error' }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { logLevel } = options;
    const adBlock = new ad_block_detection_1.AdBlockerDetection({ logLevel });
    return yield adBlock.runAllTests();
});
exports.test = test;
//# sourceMappingURL=main.js.map